import App from '@/models/App'

export default class ShipSailorInfoContractHistory extends App {
    static get entity() {
        return 'ShipSailorInfoContractHistories'
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipSailorId: this.attr(''),
            shipOwner: this.attr(''),
            dispatchShipOwner: this.attr(''),
            laborManager: this.attr(''),
            workingHours: this.attr(''),
            breakTimeCount: this.attr(''),
            isOvertime: this.attr(''),
            isCompHoliday: this.attr(''),
            isBreakTimeAddition: this.attr(''),
            isBreakTimeReduction: this.attr(''),
            isArticle72: this.attr(''),
            openedAt: this.attr(''),
            closedAt: this.attr(''),
            modifyName: this.attr(''),
            isDeleted: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static getOtherHistories(shipSailorId, contractHistoryId) {
        return this.query()
            .where((value) => {
                return (
                    value.shipSailorId === shipSailorId &&
                    value.id !== contractHistoryId &&
                    value.isDeleted === false
                )
            })
            .withAllRecursive()
            .get()
    }

    static apiConfig = {
        actions: {
            fetch(shipId, shipSailorId) {
                return this.get(
                    `${shipId}/sailors/${shipSailorId}/infos/contract/histories`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(
                shipId,
                shipSailorId,
                shipSailorInfoContractHistoryId,
                params
            ) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/contract/histories/${shipSailorInfoContractHistoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, shipSailorId, shipSailorInfoContractHistoryId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipId}/sailors/${shipSailorId}/infos/contract/histories/${shipSailorInfoContractHistoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: shipSailorInfoContractHistoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
